import { useLocation } from 'react-router-dom';
import { FeesProvider } from 'sonata-platform-components';

import { useGlobalStore } from '@/store/global';
import { getUser } from '@/store/global/user/selectors.ts';
import { LineItemStore, useStore as useLineItemStore } from '@/store/local/lineItem';
import { LineItemFormProvider } from '../../../liSettings/LineItemForm/LineItemForm.provider';

type Props = {
  children?: React.ReactNode;
};

function FormProviderWrapper({ children }: Props) {
  const { state } = useLocation();
  const user = useGlobalStore(getUser);
  const userJSON = user.toJSON();
  const liState = useLineItemStore() as LineItemStore;

  return (
    <FeesProvider entity={liState.entity.toJSON()} user={userJSON}>
      <LineItemFormProvider
        defaultCountries={state?.insertionOrder?.countries}
        defaultLineItem={liState.entity.toJSON()}
      >
        {children}
      </LineItemFormProvider>
    </FeesProvider>
  );
}

export default FormProviderWrapper;
